let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9qvFo")).then(() => parcelRequire('dRszM'));